<div class="epub-viewer-container" data-automation-id="epub-viewer-container" [class.double-spread]="isDoubleSpread && !albumMode" [attr.data-render-ready]="renderReady">
  <div class="spliter-container single-spread-container">
    <div class="spliter" data-automation-id="epub-viewer-main" role="main" aria-label="Reading content" id="main-iframe">
      <iframe #cloIframe allowfullscreen id="clo-iframe" data-automation-id="clo-iframe" title="Main content"></iframe>
    </div>
  </div>

  <div class="spliter-container double-spread-container">
    <div class="spliter left-container" data-automation-id="epub-viewer-left-page" role="main" aria-label="Reading content">
      <iframe
        #leftPageIframe
        allowfullscreen
        id="left-iframe"
        aria-label="Left page content"
        title="Left page content"
      ></iframe>
    </div>

    <div class="spliter right-container" data-automation-id="epub-viewer-right-page" role="main" aria-label="Reading content">
      <iframe
        #rightPageIframe
        allowfullscreen
        id="right-iframe"
        aria-label="Right page content"
        title="Right page content"
      ></iframe>
    </div>
  </div>
</div>
